import * as React from "react";
import type { SVGProps } from "react";
const SvgHaiti = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Haiti_svg__cls-3,.Haiti_svg__cls-6{fill:#fff}.Haiti_svg__cls-14,.Haiti_svg__cls-18,.Haiti_svg__cls-4{fill:#016a16}.Haiti_svg__cls-4{stroke:#016a16}.Haiti_svg__cls-10,.Haiti_svg__cls-11,.Haiti_svg__cls-12,.Haiti_svg__cls-13,.Haiti_svg__cls-14,.Haiti_svg__cls-15,.Haiti_svg__cls-18,.Haiti_svg__cls-4,.Haiti_svg__cls-5,.Haiti_svg__cls-6,.Haiti_svg__cls-7,.Haiti_svg__cls-8,.Haiti_svg__cls-9{stroke-width:.5px}.Haiti_svg__cls-12,.Haiti_svg__cls-5{fill:#f1b517}.Haiti_svg__cls-11,.Haiti_svg__cls-12,.Haiti_svg__cls-13,.Haiti_svg__cls-14,.Haiti_svg__cls-5,.Haiti_svg__cls-6,.Haiti_svg__cls-7,.Haiti_svg__cls-8{stroke:#000}.Haiti_svg__cls-15,.Haiti_svg__cls-7,.Haiti_svg__cls-9{fill:#0a328c}.Haiti_svg__cls-10,.Haiti_svg__cls-8{fill:#d20014}.Haiti_svg__cls-15,.Haiti_svg__cls-9{stroke:#0a328c}.Haiti_svg__cls-10{stroke:#d20014}.Haiti_svg__cls-11{fill:#503200}.Haiti_svg__cls-12,.Haiti_svg__cls-15,.Haiti_svg__cls-18{stroke-linecap:round}.Haiti_svg__cls-13{fill:none}.Haiti_svg__cls-18{stroke:#fff}"
        }
      </style>
    </defs>
    <g id="Haiti_svg__Haiti">
      <path
        id="Haiti_svg__rect6538"
        d="M0-.14h1280v720.28H0z"
        style={{
          fill: "#00209f",
        }}
      />
      <path
        id="Haiti_svg__rect6540"
        d="M0 360h1280v360.14H0z"
        style={{
          fill: "#d21034",
        }}
      />
      <g id="Haiti_svg__g2562">
        <path
          id="Haiti_svg__Background"
          d="M524.14 269.45h227.23v180.89H524.14z"
          className="Haiti_svg__cls-3"
        />
        <path
          id="Haiti_svg__Island"
          d="m683.49 400.25-46.37 1.35-46.17.52s-23.71 8.78-33.41 10.75-8.41 5.13-15.89 6.81c-6 1.33-6.68 1.76-10.2 2-2.12.14-4.74 1.77-7.31 3.58v25.09h227.23v-23.88a45 45 0 0 0-7.21-3.08c-3.34-1.13-5.59-2.38-11.58-3.71-7.48-1.68-6.22-4.85-15.89-6.81s-33.2-12.62-33.2-12.62Z"
          className="Haiti_svg__cls-4"
        />
        <path
          id="Haiti_svg__Palm-center"
          d="m634.77 301.42-1.11 21.78h7l-1-21.59 7.26-1-.81-8.6-18 .7.1 7.81Z"
          className="Haiti_svg__cls-4"
        />
        <g id="Haiti_svg__Reflected-elements">
          <g id="Haiti_svg__g3357">
            <g id="Haiti_svg__Pikes">
              <path
                id="Haiti_svg__path2976"
                d="m618.32 361.31-6.05-13 2.62-.55 11 21.62Z"
                className="Haiti_svg__cls-5"
              />
              <path
                id="Haiti_svg__path2970"
                d="m604.34 333.06 6.7 18.31h3.44Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path2980"
                d="m624.62 344.42 3.36-.08 6.13 25.81-1.31 8.13Z"
                className="Haiti_svg__cls-5"
              />
              <path
                id="Haiti_svg__path2978"
                d="m627.49 371-10.31-27.7 3.84-.24 12 33.86Z"
                className="Haiti_svg__cls-5"
              />
              <path
                id="Haiti_svg__path2972"
                d="m612.35 327.53 4.26 19.26H620Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path2974"
                d="m621.11 327.22 2.29 19.88 2.45-.15Z"
                className="Haiti_svg__cls-6"
              />
            </g>
            <g id="Haiti_svg__Flags">
              <path
                id="Haiti_svg__path3038"
                d="m619.15 363.28-27.46-30c-8.57 6.79-7 19.26-7 19.26L615.82 377Z"
                className="Haiti_svg__cls-7"
              />
              <path
                id="Haiti_svg__path3019"
                d="m635 379.77-20.37-20.63c-8.61.3-1.77 13.15-1.34 14.77L635 392.48Z"
                className="Haiti_svg__cls-8"
              />
              <g id="Haiti_svg__g2996">
                <path
                  id="Haiti_svg__path2990"
                  d="m633.29 376.22-42.11-45.09-1.65 1.16 44.57 49.51Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path2992"
                  d="m588.74 328.24-.92-1.07.09-2.14-8.69-5.53 3.89 8.74 2.95.54.93 1.07Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path2994"
                  d="M584.31 331.45a20.1 20.1 0 0 1 6.38-5.26l2.4 3.48-5.18 4.33Z"
                  className="Haiti_svg__cls-5"
                />
              </g>
              <path
                id="Haiti_svg__path3042"
                d="m607.15 371.22-34.49-27.4c-5.91 6-1 24.57-1 24.57l33.72 18.26Z"
                className="Haiti_svg__cls-7"
              />
              <path
                id="Haiti_svg__path3034"
                d="m635.76 393.41-28.38-22.72c-9.69 1.35-2.07 15.62-1.49 17.19l30 16.25Z"
                className="Haiti_svg__cls-8"
              />
              <g id="Haiti_svg__g3003">
                <path
                  id="Haiti_svg__path3005"
                  d="m634.63 388.82-61.35-46.05-1.41 1.42 64.43 50.31Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path3007"
                  d="m570.36 340.33-1.1-.9-.3-2.12-9.55-4 5.4 7.95h3l1.1.9Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path3009"
                  d="M566.57 344.23a19.8 19.8 0 0 1 5.33-6.23l3 3-4.32 5.17Z"
                  className="Haiti_svg__cls-5"
                />
              </g>
              <path
                id="Haiti_svg__path3044"
                d="M604.68 388c-.46-.11-44.46-25.07-44.46-25.07-3.2 5.41-.3 13.26 1.1 14.48.08 3.6-1.45 5.53 1.7 13.06.92 4.89 3.19 9.39 6.48 12.07 4 15.4 19.74 16.44 25.8 3.9Z"
                className="Haiti_svg__cls-7"
              />
              <path
                id="Haiti_svg__path3036"
                d="m633.8 404.45-30.13-17.66c-9.69 1.36.21 19.34.79 20.91l29.09 10.3Z"
                className="Haiti_svg__cls-8"
              />
              <g id="Haiti_svg__g3011">
                <path
                  id="Haiti_svg__path3013"
                  d="m628.74 398.05-68.07-36.23-1.16 1.61 71.8 40Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path3015"
                  d="m557.39 359.85-1.23-.72-.64-2.06-10.08-2.49 6.62 7 3-.42 1.24.72Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path3017"
                  d="M554.28 364.28a19.6 19.6 0 0 1 4.26-7l3.44 2.53-3.42 5.76Z"
                  className="Haiti_svg__cls-5"
                />
              </g>
              <g id="Haiti_svg__g3050">
                <path
                  id="Haiti_svg__path3048"
                  d="m579.68 339.06 1.41 2.46c.88-.32 9.68-8.3 9.68-8.3l6.32-.19 1.81-2c-4.63-5-9 .71-9 .71Z"
                  className="Haiti_svg__cls-9"
                />
                <path
                  id="Haiti_svg__path3046"
                  d="M584.72 343.21c.34-2.2 4.51-7.72 5.11-7.91 3.13.94 6 2.74 9.21-4.41-2.76 3.5-8.34-.07-8.34-.07l-2.41 2 .06 1-7.35 6.8Z"
                  className="Haiti_svg__cls-10"
                />
              </g>
              <g id="Haiti_svg__g3054">
                <path
                  id="Haiti_svg__path3056"
                  d="m563.15 351.94.38 2.54c.81-.45 8.55-8.94 8.55-8.94l6.21-1.15 1.26-2c-4.31-5.07-8.91 1.67-8.91 1.67Z"
                  className="Haiti_svg__cls-9"
                />
                <path
                  id="Haiti_svg__path3058"
                  d="M568.06 356.51c-.29-2.36 2.93-9.28 3.49-9.56 3.72 1.1 7 2.77 8.32-5-2.16 3.88-8.31.87-8.31.87l-2.07 2.35.3 1.28-6.27 8.09Z"
                  className="Haiti_svg__cls-10"
                />
              </g>
              <g id="Haiti_svg__g3060">
                <path
                  id="Haiti_svg__path3062"
                  d="m551.56 372.44 1.43 2.8c.74-.56 7.21-11 7.21-11l6-2 1.13-2.43c-4.81-4.44-8.4 3.22-8.4 3.22Z"
                  className="Haiti_svg__cls-9"
                />
                <path
                  id="Haiti_svg__path3064"
                  d="M558 376.41c-.48-2.39 1.16-10.07 1.68-10.43 3.75 1.12 6.87 1.44 7.74-6.29-2.18 3.67-8 2.28-8 2.28l-1.71 2.61.36.91-4.95 9.51Z"
                  className="Haiti_svg__cls-10"
                />
              </g>
            </g>
            <path
              id="Haiti_svg__Cannon-base"
              d="m628.24 414.71-17-5.26-7.39-12.61-26.15-1.29.91 9.46 22.28 4.27 2.11 3.79 25.61 7.13Z"
              className="Haiti_svg__cls-5"
            />
            <g id="Haiti_svg__Cannon-Loader">
              <path
                id="Haiti_svg__path4136"
                d="m610.54 418.23-26.77-39.37-1.32 1L609 419.38Z"
                className="Haiti_svg__cls-11"
              />
              <path
                id="Haiti_svg__path4138"
                d="m586.26 380.41-2.86-4.78a1.68 1.68 0 0 0-2.54-.55 1.84 1.84 0 0 0-.58 2.69l2.65 4.45Z"
                className="Haiti_svg__cls-6"
              />
            </g>
            <g id="Haiti_svg__Cannn-main">
              <g id="Haiti_svg__g4037">
                <path
                  id="Haiti_svg__path4012"
                  d="m613.71 393.92-54-5.49-1.31 7.85 53.75 5.41Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path4006"
                  d="m558.74 386.4-1.4 10.9h2.27l1.58-10Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path4008"
                  d="m567.76 388.18-.62 9.79 1.4.17 1.14-8.7Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path4010"
                  d="m604.35 392.4-1.35 9.2 2.63-.08 1.05-9.12Z"
                  className="Haiti_svg__cls-5"
                />
                <path
                  id="Haiti_svg__path4020"
                  d="m612.4 392.65-1.87 10.65 3 .43.85-5.6a2.58 2.58 0 0 0 5.08-.5 2.52 2.52 0 0 0-2.57-2.46 2.36 2.36 0 0 0-2.26 1.65l.56-4Z"
                  className="Haiti_svg__cls-5"
                />
              </g>
              <g id="Haiti_svg__g3987">
                <g id="Haiti_svg__g3965">
                  <g id="Haiti_svg__g3953">
                    <g id="Haiti_svg__g3943">
                      <path
                        id="Haiti_svg__path3891"
                        d="m592.9 394.38-7.43 8.36.87 1 9.53-6.5Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__use3897"
                        d="m575.63 415.22 7.43-8.36-.87-1-9.53 6.51Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3909"
                        d="m595.07 413.13-9-7-.93.66 7.12 9Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3911"
                        d="m572.78 397 9.17 6.74 1.11-.83-7.18-9Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3927"
                        d="m582.75 391.44.88 11 1.23-.06 2.9-10.68Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3929"
                        d="m585.75 418.08-.87-11-1.36-.13-1.66 11.11Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3931"
                        d="m597.9 403.28-11.51 1.22-.17 1.1 11.64 1.52Z"
                        className="Haiti_svg__cls-5"
                      />
                      <path
                        id="Haiti_svg__path3933"
                        d="m570.52 407.08 11.23-1.78.24-.87-11.62-1.3Z"
                        className="Haiti_svg__cls-5"
                      />
                    </g>
                    <path
                      id="Haiti_svg__use3882"
                      d="M587.25 404.53a3.05 3.05 0 1 1-3-2.94 3 3 0 0 1 3 2.94Z"
                      className="Haiti_svg__cls-12"
                    />
                  </g>
                  <path
                    id="Haiti_svg__use3874"
                    d="M600.4 404.53c0 8.63-7.26 15.63-16.2 15.63s-16.19-7-16.19-15.63 7.25-15.62 16.19-15.62 16.2 7 16.2 15.62Zm-3.24 0a13 13 0 1 1-13-12.5 12.75 12.75 0 0 1 13 12.5Z"
                    className="Haiti_svg__cls-12"
                  />
                </g>
                <path
                  id="Haiti_svg__path3979"
                  d="m574.08 396.65-2.53-1.91"
                  className="Haiti_svg__cls-13"
                />
                <path
                  id="Haiti_svg__path3981"
                  d="m592.22 394.8 2.17-2.21"
                  className="Haiti_svg__cls-13"
                />
                <path
                  id="Haiti_svg__path3983"
                  d="m596.86 414.5-2.66-2.09"
                  className="Haiti_svg__cls-13"
                />
                <path
                  id="Haiti_svg__path3985"
                  d="m574.08 416.89 2.29-2.45"
                  className="Haiti_svg__cls-13"
                />
              </g>
            </g>
            <g id="Haiti_svg__Axe">
              <path
                id="Haiti_svg__path4368"
                d="m628.62 389.1 2.78 14.14-2.26 1.19-2.44-15.12Z"
                className="Haiti_svg__cls-5"
              />
              <path
                id="Haiti_svg__path4370"
                d="M627.17 387.28c-1.28-.53-2.95.38-5.7-3.1-4.51 4.14-.25 4.76.43 8.85 1.28.53 2.06-3.17 5.53-3.55.43-.05 5.52-.49 5.52-.49l-1.28-1.74s-3.54.09-4.5.03Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path4372"
                d="m629 390.05-.52-4.21c-.56-1.49-2.4-.21-2.4.66l.47 3.89Z"
                className="Haiti_svg__cls-6"
              />
            </g>
            <g id="Haiti_svg__Cannon-balls">
              <path
                id="Haiti_svg__path2448"
                d="M597.6 425a1.72 1.72 0 0 1-.89 1.49 1.87 1.87 0 0 1-1.78 0 1.7 1.7 0 0 1 0-3 1.87 1.87 0 0 1 1.78 0 1.72 1.72 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3220"
                d="M593.05 421.74a1.7 1.7 0 0 1-.88 1.49 1.82 1.82 0 0 1-1.78 0 1.68 1.68 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.68 1.68 0 0 1 .88 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3222"
                d="M586.93 423.85a1.68 1.68 0 0 1-.88 1.48 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1-.89-1.48 1.72 1.72 0 0 1 .89-1.49 1.87 1.87 0 0 1 1.78 0 1.71 1.71 0 0 1 .88 1.49Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3224"
                d="M577.48 425.89a1.71 1.71 0 0 1-.89 1.49 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.71 1.71 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3226"
                d="M573.48 426.36a1.71 1.71 0 0 1-.89 1.49 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.69 1.69 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3228"
                d="M569.54 426.36a1.71 1.71 0 0 1-.89 1.49 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.69 1.69 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3230"
                d="M565.54 426.25a1.71 1.71 0 0 1-.89 1.48 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.71 1.71 0 0 1 .89 1.52Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3232"
                d="M567.48 423.21a1.71 1.71 0 0 1-.89 1.48 1.82 1.82 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.71 1.71 0 0 1 .89 1.52Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3234"
                d="M571.36 423.38a1.72 1.72 0 0 1-.89 1.49 1.87 1.87 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.87 1.87 0 0 1 1.78 0 1.72 1.72 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3236"
                d="M575.05 422.91a1.7 1.7 0 0 1-.88 1.49 1.82 1.82 0 0 1-1.78 0 1.68 1.68 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.68 1.68 0 0 1 .88 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3238"
                d="M573.18 419.93a1.72 1.72 0 0 1-.89 1.49 1.87 1.87 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.87 1.87 0 0 1 1.78 0 1.72 1.72 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
              <path
                id="Haiti_svg__path3240"
                d="M569.54 419.87a1.71 1.71 0 0 1-.89 1.49 1.87 1.87 0 0 1-1.78 0 1.69 1.69 0 0 1 0-3 1.82 1.82 0 0 1 1.78 0 1.69 1.69 0 0 1 .89 1.51Z"
                className="Haiti_svg__cls-12"
              />
            </g>
            <g id="Haiti_svg__Gunpowder">
              <path
                id="Haiti_svg__path3256"
                d="M600 413.61c-1.53-.62-1.51 2.81-1.51 2.81h2.41c1.05.48 1.9 2 1.23 2.78s-5.23-1.06-5.55-.09c.83 4.66 7 6.46 9.24 4.42s2.74-7.32-4.36-8.72Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path3258"
                d="m601.43 414.88-.7 1.53"
                className="Haiti_svg__cls-13"
              />
            </g>
            <g id="Haiti_svg__Small-flag">
              <path
                id="Haiti_svg__path3418"
                d="m553.59 415.35-2.32-9.72"
                className="Haiti_svg__cls-13"
              />
              <path
                id="Haiti_svg__path3420"
                d="m556.4 414.8-3.56-7.57"
                className="Haiti_svg__cls-13"
              />
              <path
                id="Haiti_svg__path3422"
                d="m562.51 412.8-8-4.3"
                className="Haiti_svg__cls-13"
              />
              <path
                id="Haiti_svg__path3424"
                d="m566 411.93-14.87-6.46"
                className="Haiti_svg__cls-13"
              />
              <path
                id="Haiti_svg__path3430"
                d="M542.24 398.45s-5.41-.09-6.38.29c-.39.15 1.36 2 1 2.68-1.35 2.59-10.55 2.24-11.28 1.67-1.24-1 8.57-1.81 8.63-2.47s-1.45-2.75-1.21-4c.31-1.59 4.29-2.18 4.29-2.18Z"
                className="Haiti_svg__cls-10"
              />
              <path
                id="Haiti_svg__path3426"
                d="m549.48 403.34-12.25-10.14s-.54-.57-1-.08.17 1 .17 1L549 404.6Z"
                className="Haiti_svg__cls-11"
              />
              <path
                id="Haiti_svg__path3428"
                d="M561.28 413.34c-.22-.21-10-8.66-10-8.66l-.65-2.47a24 24 0 0 0-2.06 1.55 13.4 13.4 0 0 0-1.41 2l2.73.12 8.64 7.91Z"
                className="Haiti_svg__cls-5"
              />
            </g>
            <path
              id="Haiti_svg__Trumpet"
              d="M615.59 401.71v3.93c-1.29.44-1.09 1.4-1 2.8v11.46c-.46.76-1.87.8-2.53 1.39s-.58 1.75 2.44 2.51l2.35.09c3.57-.78 4.3-2 2.51-2.63a7.7 7.7 0 0 1-2.68-1.34l.08-2.73 2.32.09c.62 0 1.8-1.57 1.84-2.85v-5.93c-.09-3.36-2.61-3.74-3.32-3.7l.05-3.1Zm3.91 6.55c0-1-1.33-1.81-1.89-1.84a2.62 2.62 0 0 0-1.8 2.08v2.41c.08.88.78 3.86 2.2 4.08.67.1 1.53-1 1.53-1.84Z"
              className="Haiti_svg__cls-5"
            />
            <g id="Haiti_svg__Palm-leaves">
              <path
                id="Haiti_svg__path3811"
                d="M637.32 292.53c-18.64-18.66-33.32-9.55-36.82-7 2.31.45 4.39-1 5.46-1.15-.67.85-2.08 2.95-2.08 2.95s5.77-2.72 6.41-2.47a10.1 10.1 0 0 0-1.75 2.24c.43.17 3.67-2.53 4.31-2.58a8.6 8.6 0 0 0-1.29 3.67l2.81-1.31c.73.52-.2 1.51.43 1.46 4.67-.38 11.23 4.27 12.13 5.7"
                className="Haiti_svg__cls-14"
              />
              <path
                id="Haiti_svg__path3813"
                d="M632.7 296c-1.94-4.46-37.42-12-44.56.58 2.8.7 5.47-2.34 5.47-2.34l-.25 2.81 4.74-3.63-1.7 3.75 3.76-3.05-.12 3.05 4.62-5-.61 2.93 4.13-1.76-.49 2.46"
                className="Haiti_svg__cls-14"
              />
              <path
                id="Haiti_svg__path3815"
                d="M631.13 296.65c-9.11-6.09-23.2-2-23.2-2-9 5-13.77 4.12-14.93 13.47.85-.35 3.28-3.28 3.28-3.28l1.82 3.63.61-5.15 1.45 4 2.19-6.56.49 4.45 3.39-4.45 1.58 1.29 1.46-3.4 1.34 2.23s2.3-1.41 3.64-.59l2.55-2.93.61 2.11 2.18-2.58.85 1.88 2.19-2-.13 1.4 7.53.12"
                className="Haiti_svg__cls-14"
              />
              <path
                id="Haiti_svg__path2477"
                d="M629.07 297.7c-6.35-.11-24.56 6.75-29.27 13.94a33 33 0 0 1 3-1.52l.92 2.89 1.14-2.89.24 2.22c.7-1.73 1.48-1.93 2.79-.11l.49-2.7.73 2.58 1.21-2.81s.77 3.05 1.22 2.93c0 0 2-5.27 2.91-5.51l.24 3.28 1.22-3.28 1.09 2.46.24-3.51 1.22 2.69s.63-2.65 1.58-3.16l1.82 1.64L630 301"
                className="Haiti_svg__cls-14"
              />
              <path
                id="Haiti_svg__path2479"
                d="M630.29 299.2c-8.46 3.24-16 14.84-15.44 19.75 3.76-4.66 2.95-4 4.63 1.35 0 0 .63-4.7 1.27-5.25l1.1 3.47.41-4.54h1.13l-.29-2.85 1.68 1.28c-.39-1.62-.81-2.17.92-3.57 0 0-2.2.28-.46-3.69l1.62 1.57s-.29-1.74.29-2.41l6-2.06"
                className="Haiti_svg__cls-14"
              />
              <g id="Haiti_svg__g2485">
                <path
                  id="Haiti_svg__path2481"
                  d="m631.1 300.07-3.19 6.09 1.64.47-3.69 2.76 3.11-.31s-4.74 1.74-5.32 6.4l4.83-2.14s-4.09 4.19-4.66 6.72l2.78-2.45a10.15 10.15 0 0 0-2.29 7.35l2-2.29c-.49 5.37-.32 5.84 2.13 9.95 0 0-.65-6.32.09-7.11l5.4 5.61-3-8s3.36 5.06 5.4 4.58l-4.25-6.48 4.17 3.4-4.75-7.11 4.43 1.34s-3.2-4-3-6.55l3 3.32s-1.15-3.8-.82-4.9l1.55.31-3-3.47 2-.4-.24-2.29 1.47-.47-.08-2.53"
                  className="Haiti_svg__cls-14"
                />
                <path
                  id="Haiti_svg__path2483"
                  d="M634.3 301.89c-5.24 7.11-2.54 18.09-5.65 23.7"
                  className="Haiti_svg__cls-13"
                />
              </g>
            </g>
            <g id="Haiti_svg__Chain">
              <path
                id="Haiti_svg__path2500"
                d="M605.27 427.2c0-.76-1.84-.43-1.84-1.32s2.81-.26 3.2.61c1.59-1.43 2.27-.39 3.24.05 1.38-2.06 3.09-2 4.76-.48 1-1.06 3.38-.71 4.21.48 1.6-1.59 3-1.2 4.12-.05.45-.83 1.1-.65 1.57-.05.85-1.51 3-1.05 3.88-.06.8-.87 1.62-.19 2.68.46.71-.67 1.86-.55 1.86.12s-1.5.45-1.5 1.14 1.1.3 1.1 1.08c0 .61-1.64.84-1.89-.14a1.61 1.61 0 0 1-2.74-.33 1.88 1.88 0 0 1-3-.14c-.68.56-1.51.64-1.89.08a2.47 2.47 0 0 1-4-.42h-.7a2.18 2.18 0 0 1-3.65 0c-2 1.48-3.27 1-4.42.05-1.31 1.6-3.31 1.49-3.77 0-.89.64-2.73.79-2.73 0s1.51-.41 1.51-1.08Zm4 .36c0 .35-.47.63-1 .63s-1-.28-1-.63.47-.62 1-.62.98.28.98.62Zm4.37-.52c0 .41-.57.75-1.26.75s-1.26-.34-1.26-.75.57-.75 1.26-.75 1.24.34 1.24.71Zm8.58.47c0 .42-.51.76-1.14.76s-1.14-.34-1.14-.76.51-.76 1.14-.76 1.12.34 1.12.76Zm-4.57-.2a1.13 1.13 0 1 1-1.11-.95 1 1 0 0 1 1.09.95Zm9.75 0a.94.94 0 0 1-1 .86.87.87 0 1 1 0-1.72.94.94 0 0 1 .98.89Zm-3 .2a.6.6 0 0 1-.64.55.56.56 0 1 1 0-1.11.61.61 0 0 1 .63.59Zm5.82.22a.77.77 0 0 1-.73.8.76.76 0 0 1-.72-.8.75.75 0 0 1 .72-.79.76.76 0 0 1 .72.82Z"
                className="Haiti_svg__cls-5"
              />
            </g>
          </g>
          <g id="Haiti_svg__use3466">
            <g id="Haiti_svg__g3357-2" data-name="g3357">
              <g id="Haiti_svg__Pikes-2" data-name="Pikes">
                <path
                  id="Haiti_svg__path2976-2"
                  d="m656.85 361.31 6-13-2.61-.55-11 21.62Z"
                  className="Haiti_svg__cls-5"
                  data-name="path2976"
                />
                <path
                  id="Haiti_svg__path2970-2"
                  d="m670.84 333.06-6.71 18.31h-3.43Z"
                  className="Haiti_svg__cls-6"
                  data-name="path2970"
                />
                <path
                  id="Haiti_svg__path2980-2"
                  d="m650.55 344.42-3.35-.08-6.14 25.81 1.31 8.13Z"
                  className="Haiti_svg__cls-5"
                  data-name="path2980"
                />
                <path
                  id="Haiti_svg__path2978-2"
                  d="M647.69 371 658 343.32l-3.85-.24-12 33.86Z"
                  className="Haiti_svg__cls-5"
                  data-name="path2978"
                />
                <path
                  id="Haiti_svg__path2972-2"
                  d="m662.82 327.53-4.25 19.26h-3.44Z"
                  className="Haiti_svg__cls-6"
                  data-name="path2972"
                />
                <path
                  id="Haiti_svg__path2974-2"
                  d="m654.07 327.22-2.29 19.88-2.46-.15Z"
                  className="Haiti_svg__cls-6"
                  data-name="path2974"
                />
              </g>
              <g id="Haiti_svg__Flags-2" data-name="Flags">
                <path
                  id="Haiti_svg__path3038-2"
                  d="m656 363.28 27.45-30c8.58 6.79 7 19.26 7 19.26L659.36 377Z"
                  className="Haiti_svg__cls-7"
                  data-name="path3038"
                />
                <path
                  id="Haiti_svg__path3019-2"
                  d="m640.15 379.77 20.37-20.63c8.61.3 1.78 13.15 1.35 14.77l-21.72 18.57Z"
                  className="Haiti_svg__cls-8"
                  data-name="path3019"
                />
                <g id="Haiti_svg__g2996-2" data-name="g2996">
                  <path
                    id="Haiti_svg__path2990-2"
                    d="M641.89 376.22 684 331.13l1.64 1.16-44.56 49.51Z"
                    className="Haiti_svg__cls-5"
                    data-name="path2990"
                  />
                  <path
                    id="Haiti_svg__path2992-2"
                    d="m686.43 328.24.93-1.07-.1-2.14 8.74-5.53-3.88 8.74-3 .54-.92 1.07Z"
                    className="Haiti_svg__cls-5"
                    data-name="path2992"
                  />
                  <path
                    id="Haiti_svg__path2994-2"
                    d="M690.87 331.45a20.2 20.2 0 0 0-6.38-5.26l-2.4 3.48 5.17 4.37Z"
                    className="Haiti_svg__cls-5"
                    data-name="path2994"
                  />
                </g>
                <path
                  id="Haiti_svg__path3042-2"
                  d="m668 371.22 34.5-27.4c5.9 6 1 24.57 1 24.57l-33.7 18.26Z"
                  className="Haiti_svg__cls-7"
                  data-name="path3042"
                />
                <path
                  id="Haiti_svg__path3034-2"
                  d="m639.42 393.41 28.37-22.72c9.7 1.35 2.08 15.62 1.5 17.19l-30 16.25Z"
                  className="Haiti_svg__cls-8"
                  data-name="path3034"
                />
                <g id="Haiti_svg__g3003-2" data-name="g3003">
                  <path
                    id="Haiti_svg__path3005-2"
                    d="m640.55 388.82 61.35-46.05 1.41 1.42-64.44 50.31Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3005"
                  />
                  <path
                    id="Haiti_svg__path3007-2"
                    d="m704.82 340.33 1.1-.9.29-2.12 9.56-4-5.4 7.95h-3l-1.1.9Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3007"
                  />
                  <path
                    id="Haiti_svg__path3009-2"
                    d="M708.61 344.23a20 20 0 0 0-5.34-6.25l-3 3 4.31 5.17Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3009"
                  />
                </g>
                <path
                  id="Haiti_svg__path3044-2"
                  d="M670.49 388c.51-.14 44.51-25.1 44.51-25.1 3.21 5.41.31 13.26-1.1 14.48-.08 3.6 1.45 5.53-1.69 13.06-.93 4.89-3.19 9.39-6.49 12.07-4 15.4-19.74 16.44-25.8 3.9Z"
                  className="Haiti_svg__cls-7"
                  data-name="path3044"
                />
                <path
                  id="Haiti_svg__path3036-2"
                  d="m641.37 404.45 30.13-17.66c9.69 1.36-.2 19.34-.78 20.91L641.63 418Z"
                  className="Haiti_svg__cls-8"
                  data-name="path3036"
                />
                <g id="Haiti_svg__g3011-2" data-name="g3011">
                  <path
                    id="Haiti_svg__path3013-2"
                    d="m646.44 398.05 68.06-36.23 1.17 1.61-71.8 40Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3013"
                  />
                  <path
                    id="Haiti_svg__path3015-2"
                    d="m717.78 359.85 1.24-.72.63-2.06 10.08-2.49-6.62 7-3-.42-1.24.72Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3015"
                  />
                  <path
                    id="Haiti_svg__path3017-2"
                    d="M720.89 364.28a19.4 19.4 0 0 0-4.25-7l-3.45 2.53 3.42 5.76Z"
                    className="Haiti_svg__cls-5"
                    data-name="path3017"
                  />
                </g>
                <g id="Haiti_svg__g3050-2" data-name="g3050">
                  <path
                    id="Haiti_svg__path3048-2"
                    d="m695.49 339.06-1.41 2.46c-.87-.32-9.68-8.3-9.68-8.3l-6.31-.19-1.82-2c4.64-5 9 .71 9 .71Z"
                    className="Haiti_svg__cls-9"
                    data-name="path3048"
                  />
                  <path
                    id="Haiti_svg__path3046-2"
                    d="M690.45 343.21c-.33-2.2-4.5-7.72-5.11-7.91-3.12.94-6 2.74-9.2-4.41 2.75 3.5 8.33-.07 8.33-.07l2.42 2-.07 1 7.33 6.81Z"
                    className="Haiti_svg__cls-10"
                    data-name="path3046"
                  />
                </g>
                <g id="Haiti_svg__g3054-2" data-name="g3054">
                  <path
                    id="Haiti_svg__path3056-2"
                    d="m712 351.94-.39 2.54c-.81-.45-8.55-8.94-8.55-8.94l-6.2-1.15-1.27-2c4.32-5.07 8.92 1.67 8.92 1.67Z"
                    className="Haiti_svg__cls-9"
                    data-name="path3056"
                  />
                  <path
                    id="Haiti_svg__path3058-2"
                    d="M707.11 356.51c.3-2.36-2.92-9.28-3.49-9.56-3.71 1.1-7 2.77-8.31-5 2.15 3.88 8.31.87 8.31.87l2.06 2.35-.29 1.28 6.27 8.09Z"
                    className="Haiti_svg__cls-10"
                    data-name="path3058"
                  />
                </g>
                <g id="Haiti_svg__g3060-2" data-name="g3060">
                  <path
                    id="Haiti_svg__path3062-2"
                    d="m723.61 372.44-1.42 2.8c-.74-.56-7.21-11-7.21-11l-6-2-1.12-2.43c4.8-4.44 8.39 3.22 8.39 3.22Z"
                    className="Haiti_svg__cls-9"
                    data-name="path3062"
                  />
                  <path
                    id="Haiti_svg__path3064-2"
                    d="M717.2 376.41c.48-2.39-1.16-10.07-1.68-10.43-3.75 1.12-6.88 1.44-7.74-6.29 2.18 3.67 8 2.28 8 2.28l1.7 2.61-.36.91 4.95 9.49Z"
                    className="Haiti_svg__cls-10"
                    data-name="path3064"
                  />
                </g>
              </g>
              <path
                id="Haiti_svg__Cannon-base-2"
                d="m646.94 414.71 16.95-5.26 7.38-12.61 26.16-1.29-.91 9.46-22.28 4.27-2.12 3.79-25.61 7.13Z"
                className="Haiti_svg__cls-5"
                data-name="Cannon-base"
              />
              <g id="Haiti_svg__Cannon-Loader-2" data-name="Cannon-Loader">
                <path
                  id="Haiti_svg__path4136-2"
                  d="m664.64 418.23 26.77-39.37 1.31 1-26.55 39.53Z"
                  className="Haiti_svg__cls-11"
                  data-name="path4136"
                />
                <path
                  id="Haiti_svg__path4138-2"
                  d="m688.92 380.41 2.85-4.78a1.69 1.69 0 0 1 2.55-.55 1.84 1.84 0 0 1 .57 2.69l-2.64 4.45Z"
                  className="Haiti_svg__cls-6"
                  data-name="path4138"
                />
              </g>
              <g id="Haiti_svg__Cannn-main-2" data-name="Cannn-main">
                <g id="Haiti_svg__g4037-2" data-name="g4037">
                  <path
                    id="Haiti_svg__path4012-2"
                    d="m661.46 393.92 54-5.49 1.32 7.85-53.78 5.41Z"
                    className="Haiti_svg__cls-5"
                    data-name="path4012"
                  />
                  <path
                    id="Haiti_svg__path4006-2"
                    d="m716.44 386.4 1.4 10.9h-2.28l-1.58-10Z"
                    className="Haiti_svg__cls-5"
                    data-name="path4006"
                  />
                  <path
                    id="Haiti_svg__path4008-2"
                    d="M707.42 388.18 708 398l-1.4.17-1.14-8.7Z"
                    className="Haiti_svg__cls-5"
                    data-name="path4008"
                  />
                  <path
                    id="Haiti_svg__path4010-2"
                    d="m670.83 392.4 1.31 9.2-2.63-.08-1-9.12Z"
                    className="Haiti_svg__cls-5"
                    data-name="path4010"
                  />
                  <path
                    id="Haiti_svg__path4020-2"
                    d="m662.78 392.65 1.87 10.65-3 .43-.85-5.6a2.56 2.56 0 0 1-2.51 2 2.47 2.47 0 1 1 0-4.94 2.36 2.36 0 0 1 2.26 1.65l-.56-4Z"
                    className="Haiti_svg__cls-5"
                    data-name="path4020"
                  />
                </g>
                <g id="Haiti_svg__g3987-2" data-name="g3987">
                  <g id="Haiti_svg__g3965-2" data-name="g3965">
                    <g id="Haiti_svg__g3953-2" data-name="g3953">
                      <g id="Haiti_svg__g3943-2" data-name="g3943">
                        <path
                          id="Haiti_svg__path3891-2"
                          d="m682.27 394.38 7.43 8.36-.86 1-9.54-6.5Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3891"
                        />
                        <path
                          id="Haiti_svg__use3897-2"
                          d="m699.54 415.22-7.42-8.36.86-1 9.54 6.51Z"
                          className="Haiti_svg__cls-5"
                          data-name="use3897"
                        />
                        <path
                          id="Haiti_svg__path3909-2"
                          d="m680.11 413.13 9-7 .93.66-7.12 9Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3909"
                        />
                        <path
                          id="Haiti_svg__path3911-2"
                          d="m702.39 397-9.16 6.74-1.11-.83 7.18-9Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3911"
                        />
                        <path
                          id="Haiti_svg__path3927-2"
                          d="m692.42 391.44-.87 11-1.24-.06-2.89-10.68Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3927"
                        />
                        <path
                          id="Haiti_svg__path3929-2"
                          d="m689.42 418.08.88-11 1.35-.13 1.66 11.11Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3929"
                        />
                        <path
                          id="Haiti_svg__path3931-2"
                          d="m677.27 403.28 11.51 1.22.18 1.1-11.65 1.52Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3931"
                        />
                        <path
                          id="Haiti_svg__path3933-2"
                          d="m704.66 407.08-11.24-1.78-.24-.87 11.63-1.3Z"
                          className="Haiti_svg__cls-5"
                          data-name="path3933"
                        />
                      </g>
                      <path
                        id="Haiti_svg__use3882-2"
                        d="M687.93 404.53a3 3 0 1 0 3-2.94 3 3 0 0 0-3 2.94Z"
                        className="Haiti_svg__cls-12"
                        data-name="use3882"
                      />
                    </g>
                    <path
                      id="Haiti_svg__use3874-2"
                      d="M674.78 404.53c0 8.63 7.26 15.63 16.19 15.63s16.2-7 16.2-15.63-7.26-15.62-16.2-15.62-16.19 7-16.19 15.62Zm3.24 0A13 13 0 1 0 691 392a12.74 12.74 0 0 0-13 12.53Z"
                      className="Haiti_svg__cls-12"
                      data-name="use3874"
                    />
                  </g>
                  <path
                    id="Haiti_svg__path3979-2"
                    d="m701.09 396.65 2.54-1.91"
                    className="Haiti_svg__cls-13"
                    data-name="path3979"
                  />
                  <path
                    id="Haiti_svg__path3981-2"
                    d="m683 394.8-2.16-2.21"
                    className="Haiti_svg__cls-13"
                    data-name="path3981"
                  />
                  <path
                    id="Haiti_svg__path3983-2"
                    d="m678.31 414.5 2.66-2.09"
                    className="Haiti_svg__cls-13"
                    data-name="path3983"
                  />
                  <path
                    id="Haiti_svg__path3985-2"
                    d="m701.09 416.89-2.29-2.45"
                    className="Haiti_svg__cls-13"
                    data-name="path3985"
                  />
                </g>
              </g>
              <g id="Haiti_svg__Axe-2" data-name="Axe">
                <path
                  id="Haiti_svg__path4368-2"
                  d="m646.55 389.1-2.77 14.14 2.26 1.19 2.43-15.12Z"
                  className="Haiti_svg__cls-5"
                  data-name="path4368"
                />
                <path
                  id="Haiti_svg__path4370-2"
                  d="M648 387.28c1.29-.53 3 .38 5.7-3.1 4.51 4.14.26 4.76-.43 8.85-1.27.53-2.06-3.17-5.53-3.55-.42-.05-5.51-.49-5.51-.49l1.28-1.74s3.49.09 4.49.03Z"
                  className="Haiti_svg__cls-6"
                  data-name="path4370"
                />
                <path
                  id="Haiti_svg__path4372-2"
                  d="m646.16 390.05.51-4.21c.56-1.49 2.4-.21 2.4.66l-.47 3.89Z"
                  className="Haiti_svg__cls-6"
                  data-name="path4372"
                />
              </g>
              <g id="Haiti_svg__Cannon-balls-2" data-name="Cannon-balls">
                <path
                  id="Haiti_svg__path2448-2"
                  d="M677.58 425a1.71 1.71 0 0 0 .88 1.49 1.87 1.87 0 0 0 1.78 0 1.69 1.69 0 0 0 0-3 1.87 1.87 0 0 0-1.78 0 1.71 1.71 0 0 0-.88 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path2448"
                />
                <path
                  id="Haiti_svg__path3220-2"
                  d="M682.12 421.74a1.71 1.71 0 0 0 .89 1.49 1.82 1.82 0 0 0 1.78 0 1.69 1.69 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.69 1.69 0 0 0-.89 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3220"
                />
                <path
                  id="Haiti_svg__path3222-2"
                  d="M688.24 423.85a1.69 1.69 0 0 0 .89 1.48 1.82 1.82 0 0 0 1.78 0 1.69 1.69 0 0 0 .89-1.48 1.72 1.72 0 0 0-.89-1.49 1.87 1.87 0 0 0-1.78 0 1.72 1.72 0 0 0-.89 1.49Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3222"
                />
                <path
                  id="Haiti_svg__path3224-2"
                  d="M697.7 425.89a1.7 1.7 0 0 0 .88 1.49 1.82 1.82 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.7 1.7 0 0 0-.88 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3224"
                />
                <path
                  id="Haiti_svg__path3226-2"
                  d="M701.7 426.36a1.7 1.7 0 0 0 .88 1.49 1.82 1.82 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.68 1.68 0 0 0-.88 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3226"
                />
                <path
                  id="Haiti_svg__path3228-2"
                  d="M705.64 426.36a1.7 1.7 0 0 0 .88 1.49 1.82 1.82 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.68 1.68 0 0 0-.88 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3228"
                />
                <path
                  id="Haiti_svg__path3230-2"
                  d="M709.64 426.25a1.7 1.7 0 0 0 .88 1.48 1.82 1.82 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.7 1.7 0 0 0-.88 1.52Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3230"
                />
                <path
                  id="Haiti_svg__path3232-2"
                  d="M707.7 423.21a1.7 1.7 0 0 0 .88 1.48 1.82 1.82 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.7 1.7 0 0 0-.88 1.52Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3232"
                />
                <path
                  id="Haiti_svg__path3234-2"
                  d="M703.82 423.38a1.72 1.72 0 0 0 .89 1.49 1.85 1.85 0 0 0 1.77 0 1.69 1.69 0 0 0 0-3 1.85 1.85 0 0 0-1.77 0 1.72 1.72 0 0 0-.89 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3234"
                />
                <path
                  id="Haiti_svg__path3236-2"
                  d="M700.12 422.91a1.71 1.71 0 0 0 .89 1.49 1.82 1.82 0 0 0 1.78 0 1.69 1.69 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.69 1.69 0 0 0-.89 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3236"
                />
                <path
                  id="Haiti_svg__path3238-2"
                  d="M702 419.93a1.72 1.72 0 0 0 .89 1.49 1.87 1.87 0 0 0 1.78 0 1.7 1.7 0 0 0 0-3 1.87 1.87 0 0 0-1.78 0 1.72 1.72 0 0 0-.89 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3238"
                />
                <path
                  id="Haiti_svg__path3240-2"
                  d="M705.64 419.87a1.7 1.7 0 0 0 .88 1.49 1.87 1.87 0 0 0 1.78 0 1.68 1.68 0 0 0 0-3 1.82 1.82 0 0 0-1.78 0 1.68 1.68 0 0 0-.88 1.51Z"
                  className="Haiti_svg__cls-12"
                  data-name="path3240"
                />
              </g>
              <g id="Haiti_svg__Gunpowder-2" data-name="Gunpowder">
                <path
                  id="Haiti_svg__path3256-2"
                  d="M675.17 413.61c1.53-.62 1.52 2.81 1.52 2.81h-2.41c-1.06.48-1.9 2-1.23 2.78s5.23-1.06 5.54-.09c-.83 4.66-7 6.46-9.24 4.42s-2.74-7.32 4.37-8.72Z"
                  className="Haiti_svg__cls-6"
                  data-name="path3256"
                />
                <path
                  id="Haiti_svg__path3258-2"
                  d="m673.74 414.88.71 1.53"
                  className="Haiti_svg__cls-13"
                  data-name="path3258"
                />
              </g>
              <g id="Haiti_svg__Small-flag-2" data-name="Small-flag">
                <path
                  id="Haiti_svg__path3418-2"
                  d="m721.59 415.35 2.31-9.72"
                  className="Haiti_svg__cls-13"
                  data-name="path3418"
                />
                <path
                  id="Haiti_svg__path3420-2"
                  d="m718.78 414.8 3.55-7.57"
                  className="Haiti_svg__cls-13"
                  data-name="path3420"
                />
                <path
                  id="Haiti_svg__path3422-2"
                  d="m712.67 412.8 8-4.3"
                  className="Haiti_svg__cls-13"
                  data-name="path3422"
                />
                <path
                  id="Haiti_svg__path3424-2"
                  d="m709.2 411.93 14.87-6.46"
                  className="Haiti_svg__cls-13"
                  data-name="path3424"
                />
                <path
                  id="Haiti_svg__path3430-2"
                  d="M732.94 398.45s5.41-.09 6.37.29c.39.15-1.36 2-1 2.68 1.35 2.59 10.55 2.24 11.27 1.67 1.25-1-8.56-1.81-8.63-2.47s1.45-2.75 1.22-4c-.31-1.59-4.3-2.18-4.3-2.18Z"
                  className="Haiti_svg__cls-10"
                  data-name="path3430"
                />
                <path
                  id="Haiti_svg__path3426-2"
                  d="m725.69 403.34 12.25-10.14s.54-.57 1-.08-.16 1-.16 1l-12.65 10.48Z"
                  className="Haiti_svg__cls-11"
                  data-name="path3426"
                />
                <path
                  id="Haiti_svg__path3428-2"
                  d="M713.9 413.34c.21-.21 10-8.66 10-8.66l.65-2.47a23 23 0 0 1 2.06 1.55 12.6 12.6 0 0 1 1.41 2l-2.73.12-8.63 7.91Z"
                  className="Haiti_svg__cls-5"
                  data-name="path3428"
                />
              </g>
              <path
                id="Haiti_svg__Trumpet-2"
                d="m659.59 401.71-.05 3.93c1.29.44 1.09 1.4 1.05 2.8v11.46c.45.76 1.87.8 2.53 1.39s.58 1.75-2.45 2.51l-2.34.09c-3.57-.78-4.31-2-2.52-2.63a7.6 7.6 0 0 0 2.68-1.34l-.07-2.73-2.32.09c-.62 0-1.81-1.57-1.85-2.85v-5.93c.08-3.36 2.61-3.74 3.31-3.7v-3.1Zm-3.92 6.55c0-1 1.34-1.81 1.89-1.84a2.62 2.62 0 0 1 1.81 2.08v2.41c-.09.88-.79 3.86-2.2 4.08-.67.1-1.54-1-1.54-1.84Z"
                className="Haiti_svg__cls-5"
                data-name="Trumpet"
              />
              <g id="Haiti_svg__Palm-leaves-2" data-name="Palm-leaves">
                <path
                  id="Haiti_svg__path3811-2"
                  d="M637.86 292.53c18.64-18.66 33.32-9.55 36.81-7-2.31.45-4.38-1-5.46-1.15.68.85 2.08 2.95 2.08 2.95s-5.76-2.72-6.41-2.47a9.8 9.8 0 0 1 1.75 2.24c-.43.17-3.67-2.53-4.31-2.58a8.5 8.5 0 0 1 1.3 3.67l-2.81-1.31c-.73.52.2 1.51-.43 1.46-4.67-.38-11.24 4.27-12.14 5.7"
                  className="Haiti_svg__cls-14"
                  data-name="path3811"
                />
                <path
                  id="Haiti_svg__path3813-2"
                  d="M642.47 296c1.94-4.46 37.43-12 44.56.58-2.79.7-5.46-2.34-5.46-2.34l.24 2.81-4.73-3.63 1.7 3.75-3.78-3.1.12 3.05-4.61-5 .61 2.93-4.12-1.8.48 2.46"
                  className="Haiti_svg__cls-14"
                  data-name="path3813"
                />
                <path
                  id="Haiti_svg__path3815-2"
                  d="M644.05 296.65c9.11-6.09 23.19-2 23.19-2 9 5 13.77 4.12 14.94 13.47-.85-.35-3.28-3.28-3.28-3.28l-1.82 3.63-.61-5.15-1.46 4-2.18-6.56-.49 4.45-3.4-4.45-1.58 1.24-1.45-3.4-1.34 2.23s-2.31-1.41-3.64-.59l-2.55-2.93-.61 2.11-2.19-2.58-.85 1.88-2.18-2 .12 1.4-7.53.12"
                  className="Haiti_svg__cls-14"
                  data-name="path3815"
                />
                <path
                  id="Haiti_svg__path2477-2"
                  d="M646.11 297.7c6.35-.11 24.55 6.75 29.26 13.94a33 33 0 0 0-3-1.52l-.93 2.89-1.13-2.89-.25 2.22c-.69-1.73-1.48-1.93-2.79-.11l-.48-2.7-.73 2.58-1.22-2.81s-.76 3.05-1.21 2.93c0 0-2-5.27-2.92-5.51l-.24 3.28-1.21-3.28-1.1 2.46-.24-3.51-1.21 2.69s-.64-2.65-1.58-3.16l-1.82 1.64-8.14-5.84"
                  className="Haiti_svg__cls-14"
                  data-name="path2477"
                />
                <path
                  id="Haiti_svg__path2479-2"
                  d="M644.89 299.2c8.45 3.24 16 14.84 15.44 19.75-3.76-4.66-3-4-4.63 1.35 0 0-.64-4.7-1.27-5.25l-1.11 3.47-.4-4.54h-1.13l.29-2.85-1.68 1.28c.39-1.62.81-2.17-.93-3.57 0 0 2.2.28.46-3.69l-1.62 1.57s.29-1.74-.29-2.41l-6-2.06"
                  className="Haiti_svg__cls-14"
                  data-name="path2479"
                />
                <g id="Haiti_svg__g2485-2" data-name="g2485">
                  <path
                    id="Haiti_svg__path2481-2"
                    d="m644.07 300.07 3.19 6.09-1.63.47 3.68 2.76-3.11-.31s4.75 1.74 5.32 6.4l-4.83-2.14s4.1 4.19 4.67 6.72l-2.78-2.45a10.15 10.15 0 0 1 2.29 7.35l-2-2.29c.49 5.37.33 5.84-2.13 9.95 0 0 .66-6.32-.08-7.11l-5.4 5.61 3-8s-3.36 5.06-5.41 4.58l4.26-6.48-4.18 3.4 4.75-7.11-4.42 1.34s3.19-4 3-6.55l-3 3.32s1.14-3.8.82-4.9l-1.56.31 3-3.47-2.05-.4.25-2.29-1.47-.47.08-2.53"
                    className="Haiti_svg__cls-14"
                    data-name="path2481"
                  />
                  <path
                    id="Haiti_svg__path2483-2"
                    d="M640.88 301.89c5.24 7.11 2.54 18.09 5.65 23.7"
                    className="Haiti_svg__cls-13"
                    data-name="path2483"
                  />
                </g>
              </g>
              <g id="Haiti_svg__Chain-2" data-name="Chain">
                <path
                  id="Haiti_svg__path2500-2"
                  d="M669.9 427.2c0-.76 1.85-.43 1.85-1.32s-2.82-.26-3.21.61c-1.58-1.43-2.26-.39-3.23.05-1.38-2.06-3.09-2-4.76-.48-1-1.06-3.38-.71-4.22.48-1.59-1.59-3-1.2-4.12-.05-.44-.83-1.1-.65-1.57-.05-.85-1.51-3-1.05-3.88-.06-.79-.87-1.61-.19-2.67.46-.72-.67-1.87-.55-1.87.12s1.51.45 1.51 1.14-1.1.3-1.1 1.08c0 .61 1.63.84 1.88-.14a1.62 1.62 0 0 0 2.75-.33 1.87 1.87 0 0 0 3-.14c.69.56 1.51.64 1.89.08a2.48 2.48 0 0 0 4.06-.42h.7a2.18 2.18 0 0 0 3.65 0c2.05 1.48 3.27 1 4.41.05 1.32 1.6 3.32 1.49 3.78 0 .88.64 2.73.79 2.73 0s-1.58-.41-1.58-1.08Zm-4 .36c0 .35.47.63 1 .63s1-.28 1-.63-.47-.62-1-.62-.97.28-.97.62Zm-4.37-.52c0 .41.56.75 1.26.75s1.25-.34 1.25-.75-.56-.75-1.25-.75-1.23.34-1.23.71Zm-8.58.47c0 .42.5.76 1.13.76s1.14-.34 1.14-.76-.51-.76-1.14-.76-1.08.34-1.08.76Zm4.57-.2a1.12 1.12 0 1 0 1.11-.95 1 1 0 0 0-1.08.95Zm-9.75 0a.93.93 0 0 0 1 .86.87.87 0 1 0 0-1.72.93.93 0 0 0-.97.89Zm3 .2a.65.65 0 1 0 .65-.56.61.61 0 0 0-.64.59Zm-5.81.22a.76.76 0 0 0 .72.8.77.77 0 0 0 .73-.8.76.76 0 0 0-.73-.79.75.75 0 0 0-.68.82Z"
                  className="Haiti_svg__cls-5"
                  data-name="path2500"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Haiti_svg__Palm-trunk">
          <path
            id="Haiti_svg__path3304"
            d="M640 399.7s2.85-23.88 2.84-34.15c0-8.09-2-26-2-26h-8.2s-1.25 17.84-1.06 25.9c.23 10.29 2.84 34.27 2.84 34.27Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3306"
            d="M632.17 340.68h9.51l-1.12-6.4h-6.89Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3310"
            d="M632.78 335.55h8.5l-1.6-6.4h-5.24Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3312"
            d="M633.33 330.36h7.08l-1.2-6.4h-4.5Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3314"
            d="M639.46 323.2h-5l-.5 2.32h5.85Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3316"
            d="M640.48 394.5h-6.3"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3318"
            d="M640.82 389.82h-7.06"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3320"
            d="M641.75 385.08h-9"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3322"
            d="M642.21 379.91h-9.36"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3324"
            d="M642.28 374.74h-9.85"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3327"
            d="M642.66 370H632"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3329"
            d="M642.69 365.72h-11.17"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3331"
            d="M642.62 360.53h-11.17"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3333"
            d="M642.25 355.4h-10.8"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3335"
            d="M641.75 350.19H632"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3337"
            d="M641.28 345.49h-8.82"
            className="Haiti_svg__cls-13"
          />
        </g>
        <g id="Haiti_svg__Drum">
          <path
            id="Haiti_svg__path2539"
            d="M637.37 397.74c-6 0-10.93 2.26-10.93 5a2.6 2.6 0 0 0 .41 1.38c1.3 1.51 5.54 2.61 10.56 2.61 4.7 0 8.7-1 10.27-2.33a2.74 2.74 0 0 0 .61-1.66c0-2.74-4.89-5-10.92-5Z"
            className="Haiti_svg__cls-15"
          />
          <path
            id="Haiti_svg__path2499"
            d="M648.39 403.17v16.95c0 2-4.92 3.6-11 3.6s-11-1.62-11-3.6v-16.95c0 2 4.92 3.6 11 3.6s11-1.61 11-3.6Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__path3288"
            d="M626.43 403.17v2.6l5.33 16.44 4.24-12.64 4.68 13.12 3.42-12.39 4.28 8.33V414l-4-8.07c-.44.12-.92.22-1.42.32l-2.47 9.15-3.47-8.65c-.59 0-1.16 0-1.72-.06l-3.49 8.71-4-10.48c-.81-.5-1.38-1.1-1.38-1.75Z"
            className="Haiti_svg__cls-10"
          />
          <g id="Haiti_svg__g3851">
            <path
              id="Haiti_svg__use3284"
              d="M648.39 417v3.17c0 2-4.92 3.6-11 3.6s-11-1.62-11-3.6V417c0 2 4.92 3.6 11 3.6s11-1.66 11-3.6Z"
              className="Haiti_svg__cls-15"
            />
            <path
              id="Haiti_svg__use2504"
              d="M641.93 420.23c-.89.13-1.85.23-2.85.28v3.16c1-.05 1.95-.15 2.85-.28Z"
              className="Haiti_svg__cls-12"
            />
            <path
              id="Haiti_svg__use2509"
              d="M630.24 419.68v3.15a22 22 0 0 0 2.85.59v-3.17a22 22 0 0 1-2.85-.57Z"
              className="Haiti_svg__cls-12"
            />
            <path
              id="Haiti_svg__use2514"
              d="M626.43 417v3.16c0 .59.45 1.14 1.21 1.63l.06-3.12c-.81-.55-1.27-1.11-1.27-1.67Z"
              className="Haiti_svg__cls-12"
            />
            <path
              id="Haiti_svg__use2519"
              d="M648.39 417.29h-.06a3.4 3.4 0 0 1-2 1.73v3.15c1.27-.59 2-1.29 2-2.07Z"
              className="Haiti_svg__cls-12"
            />
          </g>
          <path
            id="Haiti_svg__use3847"
            d="M648.39 403.28v16.84c0 2-4.92 3.6-11 3.6s-11-1.62-11-3.6v-16.84"
            style={{
              strokeWidth: ".5px",
              stroke: "#000",
              strokeLinecap: "round",
              fill: "none",
            }}
          />
          <path
            id="Haiti_svg__use3273"
            d="M645.9 402.06c0 1.21-3.8 2.18-8.49 2.18s-8.49-1-8.49-2.18 3.8-2.17 8.49-2.17 8.49.97 8.49 2.17Z"
            style={{
              fill: "#fff",
              strokeWidth: ".5px",
              strokeLinecap: "round",
              stroke: "#fff",
            }}
          />
          <path
            id="Haiti_svg__use2541"
            d="m634.63 403.67.38 3c.74.06 1.5.1 2.29.1l.56-3.1Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__use2546"
            d="m644.48 403-2.19.59.14 2.82a20 20 0 0 0 2.08-.45Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__use2551"
            d="M631.51 398.36a15 15 0 0 0-1.73.64l.3 2.26 1.4-.44Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__use2556"
            d="M637.37 397.47h-.87l.48 2.84h1.45l.57-2.77c-.53-.04-1.08-.07-1.63-.07Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__use2561"
            d="m643.78 398.47-.29 2.48 1.66.59.18-2.44a13 13 0 0 0-1.55-.63Z"
            className="Haiti_svg__cls-12"
          />
          <path
            id="Haiti_svg__path3858"
            d="m628.14 405.14.44-3.09-2.24-1.22.06 3.52Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3866"
            d="m648.31 404.47.1-3.09-2.1.63Z"
            className="Haiti_svg__cls-5"
          />
        </g>
        <g id="Haiti_svg__Mortar">
          <g id="Haiti_svg__g3619">
            <g id="Haiti_svg__use3617">
              <path
                id="Haiti_svg__use3602"
                d="M610.23 384.61c-.63-1.18-2.54-2-4.8-2s-4.14.86-4.78 2a1.8 1.8 0 0 1-.24-.86c0-1.6 2.25-2.9 5-2.9s5 1.3 5 2.9a1.76 1.76 0 0 1-.18.86Z"
                className="Haiti_svg__cls-18"
              />
            </g>
            <path
              id="Haiti_svg__path3595"
              d="M609.81 388.21c0 3.12-2 5.65-4.37 5.65s-4.37-2.53-4.37-5.65v-3.06h8.74Z"
              className="Haiti_svg__cls-18"
            />
            <path
              id="Haiti_svg__path3600"
              d="M609.78 384.16c0 1.19-1.94 2.16-4.34 2.16s-4.34-1-4.34-2.16 1.9-2.16 4.34-2.16 4.34 1 4.34 2.16"
              className="Haiti_svg__cls-3"
            />
            <path
              id="Haiti_svg__path3598"
              d="m604.45 386.59-.75-7.92h3.3l-.54 7.92Z"
              style={{
                fill: "#016a16",
                strokeWidth: ".5px",
                stroke: "#f1b517",
              }}
            />
            <path
              id="Haiti_svg__use3602-2"
              d="M610.24 384.29c-.64 1.19-2.55 2-4.8 2s-4.15-.86-4.79-2a1.9 1.9 0 0 0-.23.86c0 1.61 2.25 2.91 5 2.91s5-1.3 5-2.91a1.75 1.75 0 0 0-.18-.86Z"
              className="Haiti_svg__cls-18"
              data-name="use3602"
            />
          </g>
          <g id="Haiti_svg__g3626">
            <path
              id="Haiti_svg__path3628"
              d="m602.06 400.67 8.77.89 1.37-7.79-10.3-1"
              className="Haiti_svg__cls-5"
            />
            <path
              id="Haiti_svg__path3634"
              d="m604.35 392.4-1.35 9.2 2.63-.08 1.05-9.12Z"
              className="Haiti_svg__cls-5"
            />
          </g>
        </g>
        <g id="Haiti_svg__Helmet">
          <path
            id="Haiti_svg__path3655"
            d="M670.62 384.08c2-.28 5 2.46 5.13 5.84.14 2.68-4.06 2.54-4.06 2.54-.22 1.1-2.53 2.12-4.42 2.2s.5-3.43.5-3.43c-1.14-3 .35-6.6.35-6.6Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3657"
            d="m667.77 391.09 1.92-.07s.15 1 .5 1 .78-1 .78-1l2.92-.07"
            className="Haiti_svg__cls-13"
          />
          <path
            id="Haiti_svg__path3659"
            d="M671.69 386.07c1.63-1.18.2-3.55-.93-3.57l-2.64.07c-1.24 0-3.34 1.37-3.06 2.54a1.57 1.57 0 0 0 2 1.3c.48-.08 1.5-1.35 2-1.37.65-.04 2.1 1.41 2.63 1.03Z"
            style={{
              strokeWidth: ".5px",
              fill: "#d20014",
              stroke: "#f1b517",
            }}
          />
        </g>
        <g id="Haiti_svg__Hat-on-pole">
          <path
            id="Haiti_svg__path3710"
            d="M637.54 285.68c-1.65-.78-5.39-3.16-4.28-4.57l1.71-2.92c2.43-5.46 0-3.35-.3-5.05s9.28-.36 9.42 3.35c0 1-.71.42-.61 6.27l-1.81 3.5a8.4 8.4 0 0 1-4.13-.58Z"
            className="Haiti_svg__cls-9"
          />
          <path
            id="Haiti_svg__path3708"
            d="m638.7 299.82-2.37-2 .66-17.06 2.31.68Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3712"
            d="M641.77 286.16c1.49-.87 2.46-3.46 1.56-5-2.44-3.09-4-1.82-8.11-3.21-.81.87-2.53 2.54-2.16 3.79 5.38 2.53 3.29.38 5.07.69.96.17 1.58 1.31 3.64 3.73Z"
            className="Haiti_svg__cls-10"
          />
        </g>
        <path
          id="Haiti_svg__Anchor-left"
          d="M551.91 419.68c-1.49.18-1.76 1.89-1.2 3.45-6.45 1.82-12.22 4.18-17.9 5.78-.23-1.14 2.81-4.43 2.81-4.43.81.39 1.41 2.23 1.41 2.23.21-3.79 3.94-6.31 3.94-6.31-2.22-.29-9 2.32-9.77 3.39 0 0 2.61-.29 3 0 0 0-5.14 5.55-5.38 7.2.8 1.81 9.67 3.15 9.67 3.15-.14.47-2.61 2.24-2.61 2.24 3.53.77 8.85-1.73 10.44-3.25a15 15 0 0 1-7.38-3s.67 1.63.26 2.41c0 0-5-1.45-5.56-2.29 0-.07 11.92-3.15 17.69-4.8.21 1 1.36 3 2.73 2.52.9-.3.61-2.08.28-3.34a1.85 1.85 0 0 0 1.21.44 1.77 1.77 0 1 0 0-3.54 1.83 1.83 0 0 0-1.73 1.21c-.21-1.04-.82-3.2-1.91-3.06Zm4.53 3.66a.86.86 0 0 1-1.72 0 .86.86 0 0 1 1.72 0Z"
          className="Haiti_svg__cls-5"
        />
        <g id="Haiti_svg__Anchor-right">
          <path
            id="Haiti_svg__path3723"
            d="M741.16 427c.44-.88-.39-5.31-.39-5.31-.89.1-2.12 1.63-2.12 1.63 1.16-3.63-2.07-9.69-2.07-9.69 2.18.46 9.47 7.51 9.85 8.78 0 0-3.19-1.14-3.67-1 .52 3.62 3 5.3 4 7.18 0 0-4.15.91-3.73 4.37h-2.71c-.93-1.15.37-3.06.37-3.06l-18.58-7.78c-1.2-.5-3.89-1.73-3.49-3.17s4.84.61 5.93 1Z"
            className="Haiti_svg__cls-5"
          />
          <path
            id="Haiti_svg__path3735"
            d="m723.32 423.72 2.18-4c.78-1.06-.83-2.21-2-.86l-2.44 3.67c-1.06 2 1.21 2.55 2.26 1.19Z"
            className="Haiti_svg__cls-5"
          />
        </g>
        <g id="Haiti_svg__Banner">
          <g id="Haiti_svg__g3765">
            <g id="Haiti_svg__g3753">
              <path
                id="Haiti_svg__path3743"
                d="m593 432.91-.15-4.38-5.3.29-.3 4.77Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path3741"
                d="m554.29 439.05-7.08-4c29.22 2.67 35.18-7.52 42.24-8.06 4.34-.34 5 4.8-3.39 2.36l2.18 5.38s-20.75 11.67-41.13 6.85Z"
                className="Haiti_svg__cls-6"
              />
            </g>
            <g id="Haiti_svg__use3757">
              <path
                id="Haiti_svg__path3761"
                d="m681.57 432.91.15-4.38 6.48.15.31 4.77Z"
                className="Haiti_svg__cls-6"
              />
              <path
                id="Haiti_svg__path3763"
                d="m721.64 438 6.67-3.63c-33.46 1-25.85-5.5-42.59-7.32-4.33-.47-7.58 5.09 3.39 2.36l-2.17 5.38h5.26c11.4 7.51 26.79 8.18 37 5.77Z"
                className="Haiti_svg__cls-6"
              />
            </g>
            <path
              id="Haiti_svg__path3745"
              d="M585.94 429.41V437s18.56 6.88 51.67 6.88 51.66-6.88 51.66-6.88v-7.57s-14 6.47-51.66 6.47-51.67-6.49-51.67-6.49Z"
              className="Haiti_svg__cls-6"
            />
          </g>
          <g id="Haiti_svg__g3806">
            <path
              id="Haiti_svg__text3774"
              d="m588.71 437 1.64-5.54.76.21-1.44 4.89 2.83.77-.2.66Zm5.37-2.44.09-1.09.25-.93.81.2-.25.93-.46 1Zm8-.37.77.15-.69 3.26a4 4 0 0 1-.48 1.32 1.72 1.72 0 0 1-.9.67 2.7 2.7 0 0 1-1.43.05 3 3 0 0 1-1.29-.54 1.6 1.6 0 0 1-.58-.94 3.8 3.8 0 0 1 .08-1.46l.69-3.26.77.15-.69 3.26a3.1 3.1 0 0 0-.08 1.11 1 1 0 0 0 .37.63 1.7 1.7 0 0 0 .8.36 1.67 1.67 0 0 0 1.3-.14 2.12 2.12 0 0 0 .67-1.36Zm.87 6 1-5.69.8.12 2.34 5 .76-4.47.75.12-1 5.69-.8-.13-2.34-5-.75 4.47Zm6.1.92.82-5.71.78.1-.82 5.71Zm2.25-2.52a3.1 3.1 0 0 1 1.06-2.15 2.8 2.8 0 0 1 2.14-.58 2.93 2.93 0 0 1 1.44.54 2.5 2.5 0 0 1 .88 1.17 3.4 3.4 0 0 1 .17 1.58 3.5 3.5 0 0 1-.55 1.52 2.5 2.5 0 0 1-1.16.92 3.1 3.1 0 0 1-1.48.2 2.9 2.9 0 0 1-1.46-.56 2.6 2.6 0 0 1-.87-1.17 3.2 3.2 0 0 1-.17-1.47m.81.1a2.23 2.23 0 0 0 .38 1.69 1.93 1.93 0 0 0 1.38.76 2 2 0 0 0 1.53-.44 2.44 2.44 0 0 0 .78-1.65 2.9 2.9 0 0 0-.1-1.24 1.8 1.8 0 0 0-.63-.89 2 2 0 0 0-1-.41 2 2 0 0 0-1.5.4 2.42 2.42 0 0 0-.82 1.78Zm5.54 3.4.49-5.75.81.07 2.74 4.75.38-4.51.76.06-.49 5.75-.81-.06-2.74-4.77-.38 4.52Zm8.38.58.26-5.76 4 .17v.68l-3.24-.14-.08 1.79 2.8.12v.68l-2.8-.12-.12 2.61Zm4.4.19 2.41-5.72h.85L636 443h-.9l-.66-1.76-2.5-.05-.69 1.74Zm1.77-2.34h2l-.59-1.61a12 12 0 0 1-.4-1.2 8 8 0 0 1-.35 1.1Zm4.6 2.43v-5.76h.79V443Zm3.7 0-.08-5.09h-2v-.68l4.73-.07v.68h-2l.08 5.08Zm5.86-.14-.28-5.76h.79l.25 5.08 2.94-.13v.68Zm4-.18 1.87-5.91.85-.05 2.86 5.58-.9.06-.82-1.69-2.49.17-.53 1.78Zm1.55-2.48 2-.14-.74-1.55c-.23-.47-.4-.86-.51-1.16a7.5 7.5 0 0 1-.24 1.12Zm7 1.82-.65-5.73 4-.42.07.67-3.22.34.2 1.78 2.79-.3.08.68-2.79.3.3 2.6Zm4.39-3.29a3 3 0 0 1 .46-2.33 2.76 2.76 0 0 1 1.92-1.09 3 3 0 0 1 1.53.18 2.5 2.5 0 0 1 1.16.91 3.3 3.3 0 0 1 .57 1.49 3.3 3.3 0 0 1-.13 1.6 2.42 2.42 0 0 1-.88 1.18 2.94 2.94 0 0 1-1.38.55A2.9 2.9 0 0 1 665 441a2.56 2.56 0 0 1-1.15-.93 3.1 3.1 0 0 1-.55-1.38Zm.8-.1a2.33 2.33 0 0 0 .82 1.55 2 2 0 0 0 1.53.39 1.9 1.9 0 0 0 1.37-.8 2.42 2.42 0 0 0 .32-1.78 2.9 2.9 0 0 0-.43-1.18 1.9 1.9 0 0 0-.83-.71 2.14 2.14 0 0 0-1.1-.14 2.1 2.1 0 0 0-1.35.75 2.45 2.45 0 0 0-.33 1.92m6.28 1.94-1.07-5.67 2.61-.46a3.8 3.8 0 0 1 1.22-.06 1.36 1.36 0 0 1 .76.43 1.55 1.55 0 0 1 .4.81 1.38 1.38 0 0 1-.21 1.09 2.08 2.08 0 0 1-1.15.74 2.3 2.3 0 0 1 .52.2 4.2 4.2 0 0 1 .79.65l1.31 1.36-1 .17-1-1c-.29-.3-.52-.53-.71-.69a2.2 2.2 0 0 0-.46-.31 1.1 1.1 0 0 0-.39-.08 2 2 0 0 0-.43 0l-.91.16.48 2.52Zm.18-3.31 1.67-.29a2.8 2.8 0 0 0 .82-.25.87.87 0 0 0 .39-.42.85.85 0 0 0 .06-.54.87.87 0 0 0-.42-.61 1.47 1.47 0 0 0-1-.09l-1.86.33Zm9.44-.63h.82a2.53 2.53 0 0 1-.55 1.58 2.45 2.45 0 0 1-1.43.82 2.9 2.9 0 0 1-1.62 0 2.43 2.43 0 0 1-1.15-.88 4 4 0 0 1-.66-1.44 3.3 3.3 0 0 1 0-1.6 2.37 2.37 0 0 1 .76-1.21 3 3 0 0 1 1.34-.65 2.5 2.5 0 0 1 1.57.11 2.34 2.34 0 0 1 1.11 1l-.72.34a1.83 1.83 0 0 0-.8-.77 1.7 1.7 0 0 0-1-.07 1.9 1.9 0 0 0-1 .56 1.58 1.58 0 0 0-.44 1 3.3 3.3 0 0 0 .07 1.12 3.3 3.3 0 0 0 .51 1.2 1.6 1.6 0 0 0 .86.66 2.1 2.1 0 0 0 1 .05 1.76 1.76 0 0 0 1-.6 1.86 1.86 0 0 0 .36-1.21Zm2.2 1.57-1.61-5.55 4.16-1.12.19.65-3.4.92.49 1.7 3.19-.86.19.65-3.19.86.55 1.89 3.53-.95.19.66Z"
            />
            <path
              id="Haiti_svg__path3150"
              d="M585.94 436.12S604.5 443 637.61 443s51.66-6.88 51.66-6.88"
              style={{
                fill: "none",
              }}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgHaiti;
